import { useMemo, useState } from "react";
import { MetricToggle } from "./MetricToggle";
import { gapHeatmap, fmtDur } from "../lib/pickerSheet";
import { fmtNum } from "../lib/format";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const GapHeatmap = ({ users }) => {
  const [metric, setMetric] = useState("minutes");
  const { grid, counts } = useMemo(() => gapHeatmap(users), [users]);
  const src = metric === "minutes" ? grid : counts;
  const max = Math.max(1, ...src.flat());
  const hourTotals = Array.from({ length: 24 }, (_, h) => grid.reduce((s, r) => s + r[h], 0));
  const peak = hourTotals.indexOf(Math.max(...hourTotals));
  return (
    <div className="panel p-5 sm:p-6" data-testid="gap-heatmap">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <div>
          <h3 className="font-display text-lg font-semibold text-slate-100">Gap time heatmap</h3>
          <p className="text-xs text-slate-500" data-testid="heatmap-peak">Team-wide large gaps by weekday & hour · peak {String(peak).padStart(2, "0")}:00–{String(peak + 1).padStart(2, "0")}:00 ({fmtDur(hourTotals[peak] * 60)})</p>
        </div>
        <MetricToggle value={metric} onChange={setMetric} options={[["minutes", "Idle minutes"], ["count", "Gap count"]]} prefix="heatmap-metric" />
      </div>
      <div className="overflow-x-auto">
        <div className="min-w-[760px]">
          <div className="grid gap-[3px]" style={{ gridTemplateColumns: "44px repeat(24, minmax(0, 1fr))" }}>
            <div />
            {Array.from({ length: 24 }, (_, h) => <div key={h} className="text-[10px] font-mono text-slate-500 text-center">{String(h).padStart(2, "0")}</div>)}
            {DAYS.map((d, di) => [
              <div key={d} className="text-[11px] font-mono text-slate-400 flex items-center">{d}</div>,
              ...src[di].map((v, h) => {
                const a = v / max;
                return (
                  <div key={`${d}-${h}`} data-testid={`heat-${d.toLowerCase()}-${h}`} title={`${d} ${String(h).padStart(2, "0")}:00 · ${fmtDur(grid[di][h] * 60)} idle · ${fmtNum(counts[di][h])} gaps`}
                    className={`h-8 rounded-[3px] transition-transform hover:scale-110 ${v ? "" : "heat-zero"}`}
                    style={{ background: v ? `rgba(244, 63, 94, ${0.08 + a * 0.92})` : "rgba(100,116,139,0.08)" }} />
                );
              }),
            ])}
          </div>
          <div className="flex items-center gap-2 mt-4 text-[10px] font-mono text-slate-500">
            <span>Less</span>{[0.1, 0.3, 0.5, 0.75, 1].map((a) => <span key={a} className="h-3 w-6 rounded-sm" style={{ background: `rgba(244,63,94,${a})` }} />)}<span>More</span>
          </div>
        </div>
      </div>
    </div>
  );
};
